export default __webpack_public_path__ + "static/media/Rectangle.75bf717f.png";